import { isNumber, toNumber } from 'lodash'

import {
  COMPANY_SIZE_BUCKET_TO_STRUCTURE_ID,
  DEFAULT_STRUCTURE_OPTION_ID
} from '@/composables/onboarding-ai-step'

export const getRecommendedStructureIdFromCompanySize = companySize => {
  const value = toNumber(companySize)
  if (!isNumber(value)) {
    return null
  }

  return COMPANY_SIZE_BUCKET_TO_STRUCTURE_ID[value] ?? null
}

export const resolveSelectedStructureId = ({
  savedStructureId = null,
  recommendedStructureId = null
} = {}) => {
  return savedStructureId ?? recommendedStructureId ?? DEFAULT_STRUCTURE_OPTION_ID
}
